"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneRelatedDocumentResponsesAndPhotos = exports.cloneRelatedDocumentResponses = void 0;
var types_1 = require("../types");
var util_1 = require("./util");
var alignWithSelectionOrBoolean_1 = require("./util/alignWithSelectionOrBoolean");
function cloneRelatedDocumentResponses(args) {
    return cloneRelatedDocumentResponsesAndPhotos(__assign(__assign({}, args), { parentPhotos: [] }));
}
exports.cloneRelatedDocumentResponses = cloneRelatedDocumentResponses;
function cloneRelatedDocumentResponsesAndPhotos(args) {
    var _a;
    var parentPhotos = args.parentPhotos, parentResponses = args.parentResponses, parentSections = args.parentSections, childSections = args.childSections;
    var responses = [];
    var photos = [];
    var _loop_1 = function (parentResponse) {
        var question = util_1.findOrThrowQuestionById(parentSections, parentResponse.questionId).question;
        if (!((_a = question.formProperties) === null || _a === void 0 ? void 0 : _a.isCloneable)) {
            return "continue";
        }
        var targetQuestion = findMatchingQuestionInSection(childSections, question);
        if (targetQuestion) {
            var childResponse_1 = alignWithSelectionOrBoolean_1.alignWithSelectionOrBoolean({
                answer: parentResponse.answer,
                associatedId: parentResponse.associatedId,
                associatedRootId: parentResponse.associatedRootId,
                associatedLocation: parentResponse.associatedLocation,
                comments: parentResponse.comments,
                questionId: targetQuestion.id,
                questionRootId: targetQuestion.rootId,
                timeAnswered: new Date().toISOString(),
            }, targetQuestion);
            var childPhotos = parentPhotos
                .filter(function (p) { return p.questionRootId === question.rootId; })
                .filter(function (p) { return p.associatedId === parentResponse.associatedId; })
                .map(function (p) { return (__assign(__assign({}, p), { id: undefined, questionRootId: targetQuestion.rootId, associatedId: childResponse_1.associatedId, timeAdded: new Date().toISOString() })); });
            if (childResponse_1.answer) {
                responses.push(childResponse_1);
            }
            if (childPhotos.length) {
                photos.push.apply(photos, childPhotos);
            }
        }
    };
    for (var _i = 0, parentResponses_1 = parentResponses; _i < parentResponses_1.length; _i++) {
        var parentResponse = parentResponses_1[_i];
        _loop_1(parentResponse);
    }
    return {
        responses: responses,
        photos: photos
            .concat(clonePhotosWithoutAssociatedId(args))
            .concat(clonePhotosWithoutQuestions(args.parentPhotos)),
    };
}
exports.cloneRelatedDocumentResponsesAndPhotos = cloneRelatedDocumentResponsesAndPhotos;
function clonePhotosWithoutAssociatedId(_a) {
    var _b;
    var parentPhotos = _a.parentPhotos, parentResponses = _a.parentResponses, parentSections = _a.parentSections, childSections = _a.childSections;
    var clonedPhotos = [];
    var parentQuestions = util_1.findAllQuestionsInSections(parentSections);
    var parentResponseQuestionIds = parentResponses.map(function (r) { return r.questionId; });
    var parentQuestionsWithoutResponses = parentQuestions.filter(function (q) { return parentResponseQuestionIds.indexOf(q.id) === -1; });
    var childQuestions = util_1.findAllQuestionsInSections(childSections);
    var _loop_2 = function (question) {
        var sourceQuestion = findMatchingParentQuestion(parentQuestionsWithoutResponses, question);
        if (!sourceQuestion || !((_b = sourceQuestion.formProperties) === null || _b === void 0 ? void 0 : _b.isCloneable)) {
            return "continue";
        }
        var questionPhotos = parentPhotos
            .filter(function (parentPhoto) { return parentPhoto.questionRootId === sourceQuestion.rootId; })
            .map(function (photo) { return (__assign(__assign({}, photo), { id: undefined, questionRootId: question.rootId, timeAdded: new Date().toISOString() })); });
        clonedPhotos.push.apply(clonedPhotos, questionPhotos);
    };
    for (var _i = 0, childQuestions_1 = childQuestions; _i < childQuestions_1.length; _i++) {
        var question = childQuestions_1[_i];
        _loop_2(question);
    }
    return clonedPhotos;
}
function clonePhotosWithoutQuestions(parentPhotos) {
    return parentPhotos
        .filter(function (p) { return !p.questionRootId; })
        .map(function (photo) { return (__assign(__assign({}, photo), { id: undefined, timeAdded: new Date().toISOString() })); });
}
function findMatchingQuestionInSection(childSections, relatedSourceQuestion) {
    var byRootId = util_1.findQuestionByRootId(childSections, relatedSourceQuestion.rootId);
    if (byRootId) {
        return byRootId.question;
    }
    for (var _i = 0, childSections_1 = childSections; _i < childSections_1.length; _i++) {
        var section = childSections_1[_i];
        for (var _a = 0, _b = section.items; _a < _b.length; _a++) {
            var item = _b[_a];
            if (types_1.isQuestionDTO(item) &&
                item.subType === relatedSourceQuestion.subType &&
                item.title.toLowerCase() === relatedSourceQuestion.title.toLowerCase()) {
                return item;
            }
        }
    }
    return undefined;
}
function findMatchingParentQuestion(parentQuestions, relatedChildQuestion) {
    var question = parentQuestions.find(function (p) { return p.rootId === relatedChildQuestion.rootId; });
    if (question) {
        return question;
    }
    for (var _i = 0, parentQuestions_1 = parentQuestions; _i < parentQuestions_1.length; _i++) {
        var parentQuestion = parentQuestions_1[_i];
        if (parentQuestion.subType === relatedChildQuestion.subType &&
            parentQuestion.title.toLowerCase() ===
                relatedChildQuestion.title.toLowerCase()) {
            return parentQuestion;
        }
    }
    return undefined;
}
//# sourceMappingURL=startRelated.js.map